module.exports = "/static/assets/4e76098e6208b7107977084461383563.png";